<template>
  <ul>
    <li v-for="tierPrice in product.tier_prices" :key="tierPrice.qty">
      Kaufen Sie {{ tierPrice.qty }} zum Preis von je <strong>{{ tierPrice.value | price }}</strong>
      und <strong>sparen Sie {{ percent(tierPrice.value) }}%</strong>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    product: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    percent (tierPrice) {
      const finalPrice = (this.product.final_price) ? this.product.final_price : this.product.original_price_incl_tax
      return Math.round((1 - (tierPrice / finalPrice)) * 100);
    }
  }
}
</script>
